const normalizeMediaField = (value) =>
  typeof value === "string" ? value.trim() : "";

export const getPostThumbnail = (post) =>
  normalizeMediaField(post?.thumbnail) ||
  normalizeMediaField(post?.coverImage) ||
  normalizeMediaField(post?.image) ||
  "";

// Builds a lightweight, auto-format/quality Cloudinary thumbnail URL by inserting
// a transformation segment right after `/upload/`. Non-Cloudinary URLs (manually
// pasted or scraped from post content) are returned unchanged. Idempotent.
export const cloudinaryThumb = (url, { width = 500 } = {}) => {
  const src = normalizeMediaField(url);
  if (!src || !src.includes("res.cloudinary.com") || !src.includes("/upload/")) {
    return src;
  }

  const [prefix, rest] = src.split("/upload/");
  // already has a transformation segment? leave it alone
  if (/^(?:[^/]*\b(?:f_auto|q_auto|w_\d+)\b[^/]*)\//.test(rest)) {
    return src;
  }

  return `${prefix}/upload/f_auto,q_auto,c_fill,w_${width}/${rest}`;
};
